<template>
  <div class="container">
    <slot name="left"></slot>
    <slot name="right"></slot>
  </div>
</template>
<script>
export default {
  name: 'my-container'
}
</script>
<style  scoped>
.container {
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: space-between;
  -ms-flex-pack: space-between;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  /*   -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center; */
}
</style>